import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import Icon from './Icon';
import { WEEKDAY_SHORT, weekDays } from '../lib/dates';
import { localDate, weekQuery } from '../lib/schedule';
import { useApp, useAppPath } from '../lib/AppContext';

// "Tuần này" on Today → Tập luyện: which days of the week had a workout, and for a student with a coach the
// week's appointments with a link to "Lịch tập với Coach". Reloads when `workouts` (the day's count) changes.
export default function WeekCard({ date, workouts: dayWorkouts = 0 }) {
  const { api, editable } = useApp();
  const path = useAppPath();
  const days = weekDays(date);
  const [workouts, setWorkouts] = useState(null);
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/stats?${new URLSearchParams({ from: days[0], to: days[6], group: 'day' })}`)
      .then((data) => !cancelled && setWorkouts(new Set(data.series.filter((r) => r.workout_day).map((r) => r.period))))
      .catch(() => {});
    if (editable) api.get(`/appointments?${weekQuery(date)}`).then((data) => !cancelled && setSchedule(data)).catch(() => {});
    return () => { cancelled = true; };
  }, [api, days[0], editable, dayWorkouts]); // eslint-disable-line react-hooks/exhaustive-deps

  const appointments = schedule?.appointments;
  const booked = new Set((appointments || []).filter((a) => a.state !== 'absent').map((a) => localDate(a.starts_at)));
  const trained = workouts ? workouts.size : null;
  return (
    <section className="flex flex-col gap-3 rounded-[20px] bg-base-100 p-4">
      <div className="flex items-baseline justify-between">
        <h2 className="font-bold">Tuần này</h2>
        <span className="text-sm text-muted">{trained == null ? '…' : `Đã tập ${trained} buổi`}</span>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {days.map((d, i) => (
          <div key={d} className="flex flex-col items-center gap-1">
            <span className="text-[10px] font-semibold text-muted">{WEEKDAY_SHORT[i]}</span>
            <span className={`grid size-8 place-items-center rounded-full text-xs font-bold ${workouts?.has(d) ? 'bg-[#17804f] text-white'
              : booked.has(d) ? 'border-2 border-dashed border-[#17804f] text-[#17804f]' : 'bg-base-200 text-muted'}`}>
              {workouts?.has(d) ? <Icon name="check" className="size-4" /> : ''}
            </span>
          </div>
        ))}
      </div>
      {schedule?.coach && (
        <Link to={path('/schedule')} className="flex min-h-11 items-center justify-between rounded-[14px] bg-base-200 px-3 text-sm font-semibold">
          <span>{appointments ? `Coach hẹn ${appointments.length} buổi tuần này` : 'Lịch tập với Coach'}</span>
          <Icon name="chevronRight" className="size-4 text-muted" />
        </Link>
      )}
    </section>
  );
}
